export class Category {
    category_id: number;
    label: string;

}